import { ENV } from 'configs/constants';
import { COOKIE_KEYS, LOCAL_STORAGE_KEYS } from 'constants/common';

export const getAccessToken = () => {
  return localStorage.getItem(LOCAL_STORAGE_KEYS.AUTH_TOKEN);
};

export const setAccessToken = (accessToken: string) => {
  localStorage.setItem(LOCAL_STORAGE_KEYS.AUTH_TOKEN, accessToken);
};

export const resetUserStorage = () => {
  localStorage.removeItem(LOCAL_STORAGE_KEYS.AUTH_TOKEN);
};

export const getAuthCookie = (name: string) => {
  const nameEQ = name + '=';
  const splitCookies = document.cookie.split(';');
  const currentCookie = splitCookies.find((c) => c.trim().includes(nameEQ));

  if (currentCookie) {
    return currentCookie.substring(nameEQ.length + 1);
  }

  return null;
};

export const getCookie = (name: string) => {
  const nameEQ = name + '=';
  const splitCookies = document.cookie.split(';');
  const currentCookie = splitCookies.find((c) => c.trim().includes(nameEQ));

  if (currentCookie) {
    return currentCookie.substring(nameEQ.length);
  }

  return null;
};

export const getDomain = () => {
  const isLocalhost = window.location.hostname === 'localhost';
  const domain = isLocalhost ? '' : '; domain=' + ENV.WEB_DOMAIN;
  return domain;
};

export const setAccessTokenToCookie = (
  accessToken: string,
  encryptedAccessToken: string,
  storybookAuthToken: string,
  expireDate: number
) => {
  if (expireDate) {
    const date = new Date();
    date.setTime(date.getTime() + expireDate * 1000);
    const expires = '; expires=' + date.toUTCString();
    const domain = getDomain();

    document.cookie = 'enc_auth_token=' + encryptedAccessToken + expires + '; path=/' + domain;
    document.cookie = 'Abp.AuthToken=' + accessToken + expires + '; path=/' + domain;
    document.cookie = 'storybook_auth_token=' + accessToken + expires + '; path=/' + domain;
  }
};

export const clearCookies = (name: string) => {
  document.cookie = name + '=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
};

export const resetUserAuthStorage = () => {
  clearCookies(COOKIE_KEYS.AUTH_TOKEN);
  clearCookies(COOKIE_KEYS.ENC_AUTH_TOKEN);
  clearCookies(COOKIE_KEYS.LOCALIZATION_CULTURE_NAME);
  clearCookies(COOKIE_KEYS.STORYBOOK_AUTH_TOKEN);
};

export const getTokenFromCookies = (cookieName = 'storybook_auth_token'): string | null => {
  const match = document.cookie.match(new RegExp(`(^| )${cookieName}=([^;]+)`));
  return match ? match[2] : null;
};
